<template>
  <div class="page mescroll-touch">
    <img src="../../assets/images/acmedback.png" class="topimg" alt="" />
    <div class="totle">
      <div class="title">您已进入缴费流程</div>
      <div class="model1">
        <img src="../../assets/images/pay1.png" alt="" class="simg">
        <div class="jytext">中国医药教育协会1</div>
        <div class="jynum">020056031675038</div>
      </div>
      <img src="../../assets/images/dashline.png" alt="" class="lineimg">
      <div class="upmain">
        <div class="row1">
          <div class="qr">
            <img src="../../assets/images/payqr.png" alt="" class="qrimg">
          </div>
          <!-- <div class="upload"> -->
          <van-uploader v-model="fileList" :after-read="afterRead" multiple :max-count="1" class="uptotal">
          </van-uploader>
          <!-- </div> -->
        </div>
        <div class="row1">
          <div class="qrtext">
            <div class="jfje">缴费金额:500元</div>
            <div class="jffz">(每年100元,一次性需交纳5年)</div>
          </div>
          <div class="uploadout">
            <div class="submit" @click="submit">确认提交</div>
          </div>
        </div>
      </div>

      <div class="redbtext">汇款请注明：姓名+皮肤与健康教育专委会<br />转账凭证请截图上传</div>

      <div class="bottomimg">
        <img src="../../assets/images/pay2.png" alt="" class="pay2img">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  name: "uploadInfo",
  data() {
    return {
      apiUrl: process.env.BASE_URL,
      fileList: [],
      headers: {
        token: "",
      },
      sourcefile: [],
      fileUrl: "",
    };
  },
  computed: {},
  created() {
    document.title = "加入ACMED";
  },
  beforeDestroy() { },
  methods: {
    goPay() {
      this.$dialog.alert({
        title: '提示',
        message: '升级中，敬请期待！',
      }).then(() => {
        // on close
      });
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      console.log(file);
      const formData = new FormData();
      formData.append("file", file.file);
      this.$axios
        .post("/api/api/web/ImgFile/UploadImg", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          if (res.RetCode == 10000) {
            this.fileUrl = res.Data.Url;
          }
        });
    },
    submit() {
      let that = this;
      // if (this.sourcefile.length == 0) {
      if (!this.fileUrl) {
        this.$message({
          message: "请选择文件！",
          type: "error",
        });
        return false;
      }
      let param = {
        // FileUrl: this.sourcefile[0].url,
        PayResultUrl: this.fileUrl,
      };
      this.$axios
        .post("/api/api/web/Customer/ACMEDUploadPayResult", param)
        .then((res) => {
          if (res.RetCode == "10000") {
            this.$message({
              message: "上传成功！",
              type: "success",
            });
            this.$router.push("/newpayok");
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  height: 100%;
  // position: relative;
  background: rgb(247, 249, 253);
}

.totle {
  position: relative;
  width: 100%;
  // top: 47%;
  // transform: translateY(-50%);
  text-align: center;
  z-index: 100;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.maintitle {
  margin: auto;
  text-align: center;
  position: absolute;
  left: 17%;
  top: 18%;
  width: 28%;
  height: 64%;
  background: unset;
  border: 0;
  color: transparent;
}

.okqrcode {
  display: block;
  margin: auto;
  width: 55%;
  margin-top: 1rem;
}

.maininner {
  width: 73%;
  margin: auto;
  font-size: 20px;
}

.topimg {
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}

.youarein {
  width: 85%;
  margin: auto;
  position: relative;
  margin-bottom: 1.5rem;
}

.yrinimg {
  display: block;
  width: 100%;
  margin: auto;
}

.inqrimg {
  display: block;
  width: 100%;
  margin: auto;
}

.qrout {
  width: 58%;
  margin: auto;
}

.title {
  color: rgb(54, 68, 104);
  font-size: .6rem;
  font-weight: bold;
}

.simg {
  display: block;
  margin: auto;
  width: 13%;
  margin-top: .8rem;
  margin-bottom: 0.5rem;
}

.jytext {
  color: #364468;
  font-size: .43rem;
  margin-bottom: 0.2rem;
}

.jynum {
  color: rgb(189, 189, 189);
  font-size: .43rem;
  margin-bottom: 0.2rem;
}

.model1 {
  padding-bottom: 0.5rem;
}

.lineimg {
  display: block;
  width: 80%;
  margin: auto;
  margin-bottom: 0.8rem;
}

.upmain {
  display: flex;
  flex-direction: column;
  width: 80%;
  margin: auto;
}

.row1 {
  display: flex;
  flex-direction: row;
}

.qr {
  width: 48%;
  margin-right: 4%;
}

.qrimg {
  display: block;
  width: 100%;
}

.upload {
  width: 48%;
}

.qrtext {
  width: 48%;
  margin-right: 4%;
}

.uploadout {
  width: 48%;
}

.uptotal {
  width: 48%;
}

.jfje {
  font-size: .5rem;
  font-weight: bold;
  color: #364468;
}

.jffz {
  font-size: .29rem;
  margin-top: 0.1rem;
  color: #364468;
  font-weight: bold;
}

::v-deep .van-uploader__wrapper {
  width: 100%;
  height: 100%;
  justify-content: center;
  margin: 0;
}

::v-deep .van-uploader__upload {
  width: 100%;
  height: 100%;
  border: 1px solid rgb(182, 215, 234);
  border-radius: 8px;
  margin: 0;
}

::v-deep .van-uploader__preview {
  width: 100%;
  height: 100%;
  border: 1px solid rgb(182, 215, 234);
  border-radius: 8px;
  margin: 0;
}

::v-deep .van-uploader__preview-image {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  margin: 0;
}

.submit {
  // width: 80%;
  margin: auto;
  height: 35px;
  line-height: 35px;
  border-radius: 35px;
  background: linear-gradient(to right, rgb(0, 72, 148), rgb(1, 153, 226));
  color: #ffffff;
  text-align: center;
  margin-top: 0.2rem;
}

.redbtext {
  margin: 1rem;
  font-size: .43rem;
  font-weight: bold;
  color: red;
}

.bottomimg {
  width: 80%;
  margin: auto;
}

.pay2img {
  width: 100%;
}
</style>